import * as React from 'react';

import { ChangeHandler } from 'types/typescript/eventHandlers';
import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import Dialog from 'components/Dialog';
import FormElement from 'components/FormElement';
import Input from 'components/Input';
import QuickPromotion from 'entities/QuickPromotion';
import TitleHeader from 'components/TitleHeader';

export type Props = {
  promotion: QuickPromotion;
  onConfirm: (data: any) => void;
  submissionDataFieldName: string;
  inputPlaceholder: string;
  inputName: string;
  inputValidation: ChangeHandler<HTMLInputElement>;
};

type State = {
  userInput?: string;
};

export default class QuickPromotionInputModal extends React.Component<Props, State> {
  state: State = {
    userInput: undefined,
  };

  handleConfirm = () => {
    this.props.onConfirm({ [this.props.submissionDataFieldName]: this.state.userInput });
  };

  render() {
    const { promotion } = this.props;
    return (
      <Dialog size="small" hideOnBlur={false} onRequestHide={() => {}}>
        <BoxBody>
          <TitleHeader
            title={promotion.getHeader()}
            subtext={promotion.getBody()}
            image={promotion.getImageUrl()}
          />
          <FormElement
            data-test="form-element"
            validate={this.props.inputValidation}
            label={this.props.inputName}
            labelHidden
            onValidChange={e => this.setState({ userInput: e.target.value })}
            onInvalidChange={() => this.setState({ userInput: undefined })}
            element={Input}
            elementProps={{
              name: this.props.inputName,
              placeholder: this.props.inputPlaceholder,
            }}
          />
          <Button
            full
            disabled={!this.state.userInput}
            data-test="submit-button"
            onClick={this.handleConfirm}>
            Submit
          </Button>
        </BoxBody>
      </Dialog>
    );
  }
}
